import useInvoiceManagementData from "@app/data-hooks/use-invoice-management-data.ts";
import { invoiceIncludedItemsTableDefinition } from "@app/table-definitions/invoice-included-items.table-definition.tsx";
import { DataTable } from "bi-lib";

interface Props {
    invoiceId: number;
    categoryId: number;
    title?: string;
}

export default function InvoiceIncludedItemsTable({ invoiceId, categoryId, title }: Props) {
    const { includedEntries, includedEntriesTotals } = useInvoiceManagementData({
        id: invoiceId,
        categoryId,
    });

    return (
        <DataTable
            rowsPerPageOptions={[5000]}
            label={title}
            columns={invoiceIncludedItemsTableDefinition({
                quantityTotal: includedEntriesTotals.data?.quantityTotal ?? 0,
                billAmountTotal: includedEntriesTotals.data?.billingAmountTotal ?? 0,
                rowCount: includedEntries.data?.length ?? 0,
            })}
            data={includedEntries.data ?? []}
            queryHook={includedEntries}
        />
    );
}
